import { Route } from '@angular/router';

export const rankedGamesStatisticsRoutes: Route[] = [
    {
        path: 'ranked/match',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/ranked-match-statistics/ranked-match-statistics.component').then(
                (c) => c.RankedMatchStatisticsComponent
            ),
    },
];
